app.controller("SessionEditSelectedController", [
    "$scope", "$uibModalInstance", "StaticData", "toastr", "Selection", "Students", "params",
    function ($scope, $uibModalInstance, StaticData, toastr, Selection, Student, params) {
        $scope.sessions = params.sessions;
        $scope.selection = params.subjectSelection;
        $scope.seminar = null;
        $scope.lecture = null;

        $scope.update = function () {
            $uibModalInstance.close({
                seminar: $scope.seminar,
                lecture: $scope.lecture
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);